module.exports = __webpack_public_path__ + "static/odi-logo-29536487a3f4f832e67c0a311cbed81c.png";